__turbopack_context__.v({
  "className": "inter_9f600e88-module__gNV4tq__className",
});
